export default __webpack_public_path__ + "static/media/11-41.9f183540.png";